if (!customElements.get('ar-sticky-atc')) {
  customElements.define('ar-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      this.scope = document.querySelector('product-info.ar-product-scope');
      this.main = this.scope?.querySelector('product-form [name="add"]');
      this.button = this.querySelector('.ar-sb__add');
      if (!this.main || !this.button) return;
      this.sync = () => {
        const busy = this.main.getAttribute('aria-disabled') === 'true';
        this.button.disabled = this.main.disabled || busy;
        const label = this.main.querySelector('span:not(.sold-out-message)');
        if (label) this.button.textContent = label.textContent.trim();
        const choice = this.scope.querySelector('ar-buy-qty input:checked');
        if (choice?.dataset.total) this.querySelector('.ar-sb__p').textContent = choice.dataset.total;
        if (choice?.dataset.title) this.querySelector('.ar-sb__n').textContent = choice.dataset.title;
      };
      this.add = () => { if (!this.button.disabled) this.main.click(); };
      this.button.addEventListener('click', this.add);
      this.scope.addEventListener('change', this.sync);
      this.mutations = new MutationObserver(this.sync);
      this.mutations.observe(this.main, { attributes: true, childList: true, subtree: true });
      this.sync();
      this.mobile = window.matchMedia('(max-width: 749px)');
      /* keyboard up (a text field focused) or the review form open: the bar hides, so the page never jumps under the customer's thumb */
      this.typing = () => { const a = document.activeElement; return !!(a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)); };
      this.reviewOpen = () => [...document.querySelectorAll('.jdgm-write-review-modal, [class*="jdgm-write-review-modal"]')].some((m) => m.offsetParent !== null && m.children.length);
      this.render = () => {
        const shown = this.mobile.matches && this.past && !this.typing() && !this.reviewOpen();
        this.classList.toggle('is-on', !!shown);
        this.inert = !shown;
        this.setAttribute('aria-hidden', shown ? 'false' : 'true');
        document.body.classList.toggle('ar-sb-pad', !!shown);
      };
      this.mobile.addEventListener('change', this.render);
      this.onFocus = () => setTimeout(this.render, 50);
      document.addEventListener('focusin', this.onFocus);
      document.addEventListener('focusout', this.onFocus);
      /* shown once the product photos have scrolled past (not only after the buy box), hidden while the real button is on screen */
      this.gallery = document.querySelector('.product__media-wrapper') || this.main;
      this.galleryPast = false; this.buttonSeen = true;
      this.update = () => { this.past = this.galleryPast && !this.buttonSeen; this.render(); };
      /* the photos have moved up by ~120px (the customer has started scrolling) */
      this.observer = new IntersectionObserver(([entry]) => {
        this.galleryPast = entry.boundingClientRect.top < -120;
        this.update();
      }, { threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] });
      this.observer.observe(this.gallery);
      /* the real button counts as seen only in the top three quarters of the screen */
      this.buttonObserver = new IntersectionObserver(([entry]) => {
        this.buttonSeen = entry.isIntersecting;
        this.update();
      }, { rootMargin: '0px 0px -25% 0px' });
      this.buttonObserver.observe(this.main);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.buttonObserver?.disconnect();
      this.mutations?.disconnect();
      this.mobile?.removeEventListener('change', this.render);
      document.removeEventListener('focusin', this.onFocus);
      document.removeEventListener('focusout', this.onFocus);
      this.scope?.removeEventListener('change', this.sync);
      this.button?.removeEventListener('click', this.add);
      document.body.classList.remove('ar-sb-pad');
    }
  });
}
